import {
  Component,
  OnInit,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { AppValidators } from '../../../core/validators/app-validators';
import constants from '../../../utility/constants';
import { AuctionContact, AuctionLocation, AuctionStep4 } from '../../../models';
import { ToastrService } from 'ngx-toastr';
import { AuctionService, CmsService, LoaderService } from '../../../services';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import messages from '../../../utility/messages';
import {  Subscription } from 'rxjs';

export enum modal {
  Location = 1,
  Contact,
}

@Component({
  selector: 'app-add-auction-step4',
  templateUrl: './add-auction-step4.component.html',
  styleUrls: ['./add-auction-step4.component.css'],
})
export class AddAuctionStep4Component implements OnInit {
  @Input('isEditMode') editMode: boolean;
  @Input('auctionId') auctionId: number;
  @Input('auctionStatus') auctionStatus: number;
  @Output('goToStep') step: EventEmitter<number> = new EventEmitter();
  modalRef: BsModalRef;

  displayedColumns: string[] = ['locationName', 'address', 'lot', 'action'];

  displayedColumns2: string[] = [
    'contactName',
    'address',
    'email',
    'mobileNumber',
    'action',
  ];

  fieldMaxLengthShort: number = constants.common.validations.maxLength50;
  fieldMaxLengthMid: number = constants.common.validations.maxLength150;
  minMobileNumberLength: number = constants.common.validations.maxLength10;
  mobileNumberLength: number = constants.common.validations.maxLength30;
  fieldMaxLength: number = constants.common.validations.maxLength100;
  fieldMaxLengthMedium: number = constants.common.validations.maxLength500;
  fieldMaxLengthLong: number = constants.common.validations.maxLength1500;
  fieldMaxLengthLonger: number = constants.common.validations.maxLength2500;
  fieldMaxLengthMuchLonger: number = constants.common.validations.maxLength5000;
  fieldMaxLengthLongest: number = constants.common.validations.maxLength10000;
  fieldMaxLengthMediumMost: number = constants.common.validations.maxLength200;

  locationForm: FormGroup;
  locations = new MatTableDataSource<AuctionLocation>([]);
  addEditLocationsList: Array<AuctionLocation> = [];
  isLocationEdit: boolean = false;
  currentLocationIndex: number = 0;

  staticRiggingData: string = '';
  staticSaletaxData: string = '';
  staticRemovalData: string = '';
  staticInspectionData: string = '';

  riggingData: string = '';
  removalData: string = '';
  saletaxData: string = '';
  inspectionData: string = '';
  addressData: string = '';

  loading: boolean = false;
  modalType: number;
  contactForm: FormGroup;
  contacts = new MatTableDataSource<AuctionContact>([]);
  addEditContactsList: Array<AuctionContact> = [];
  isContactEdit: boolean = false;
  currentContactIndex: number = 0;
  contactDisable: boolean;
  locationDisable: boolean;
  contactLength: number;
  locationLength: number;

  isSaleTaxLimitReached: boolean;
  isRemovalLimitReached: boolean;
  isRiggingLimitReached: boolean;
  isInspectionLimitReached: boolean;

  locationSubmitted: boolean = false;
  contactSubmitted: boolean = false;

  cmsPageIds = constants.common.cmsPages;
  saveUpdate: string;
  showButtonText: string;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private modalService: BsModalService,
    private toastr: ToastrService,
    private auctionService: AuctionService,
    private router: Router,
    private loaderService: LoaderService,
    private cmsService: CmsService
  ) { }

  ngOnInit() {
    this.bindFormData();
    this.initiateLocationForm();
    this.initiateContactForm();
    this.getCmsPageData();
  }

  private getCmsPageData() {
    const pages = this.cmsService.getCmsPage(this.cmsPageIds.riggingInfo).subscribe((res) => {
      this.staticRiggingData = res.description;
      if (!this.locationForm.value.riggingAndShipping) {
        this.locationForm.patchValue({
          riggingAndShipping: this.staticRiggingData,
        });
        this.locationForm.updateValueAndValidity();
      }
    });
    this.subscriptions.push(pages);

    const texinfo = this.cmsService.getCmsPage(this.cmsPageIds.saleTaxInfo).subscribe((res) => {
      this.staticSaletaxData = res.description;
      if (!this.locationForm.value.salesTaxDetail) {
        this.locationForm.patchValue({
          salesTaxDetail: this.staticSaletaxData,
        });
        this.locationForm.updateValueAndValidity();
      }
    });
    this.subscriptions.push(texinfo);

    this.staticInspectionData = constants.admin.initialValues.inspectionPreview;

    const cmspage = this.cmsService
      .getCmsPage(this.cmsPageIds.defaultRemovalDatesRules)
      .subscribe((res) => {
        this.staticRemovalData = res.description;
        if (!this.locationForm.value.removalDateAndRules) {
          this.locationForm.patchValue({
            removalDateAndRules: this.staticRemovalData,
          });
          this.locationForm.updateValueAndValidity();
        }
      });
      this.subscriptions.push(cmspage);
  }

  initiateLocationForm() {

    this.locationForm = new FormGroup({
      id: new FormControl(0),
      name: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
        Validators.maxLength(this.fieldMaxLengthMid),
      ]),
      address: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
      ]),
      locationLink: new FormControl(null, [
        AppValidators.noWhitespace,
        AppValidators.checkWebAddress,
      ]),
      lotNumbers: new FormControl('TBD', [
        AppValidators.noWhitespace,
        AppValidators.locationLotNum,
        Validators.maxLength(this.fieldMaxLength),
      ]),
      salesTaxRate: new FormControl(null, [
        AppValidators.noWhitespace,
        AppValidators.onlyPercentage,
      ]),
      removalDateAndRules: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
      ]),
      salesTaxDetail: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
      ]),
      inspectionPreview: new FormControl(constants.admin.initialValues.inspectionPreview, [
        AppValidators.noWhitespace,
        Validators.required,
      ]),
      riggingAndShipping: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
      ]),
      isDeleted: new FormControl(false),
    });
  }

  editorContent(
    event: { data: string; limitReached: boolean },
    control: AbstractControl
  ) {
    control.patchValue(event.data);
    control.markAsDirty();
    if (event.limitReached) control.setErrors({ invalid: true });
    else control.setErrors(null);
    control.updateValueAndValidity();
  }

  editLocation(index: number) {
    let data = this.locations.data[index];
    this.addressData = data.address;
    this.removalData = data.removalDateAndRules;
    this.saletaxData = data.salesTaxDetail
      ? data.salesTaxDetail
      : this.staticSaletaxData;
    this.riggingData = data.riggingAndShipping
      ? data.riggingAndShipping
      : this.staticRiggingData;
    this.inspectionData = data.inspectionPreview
    ? data.inspectionPreview
    : this.staticInspectionData;
    this.locationForm.patchValue({
      id: data.id,
      name: data.name,
      address: data.address,
      locationLink: data.locationLink,
      lotNumbers: data.lotNumbers,
      salesTaxRate: data.salesTaxRate,
      removalDateAndRules: data.removalDateAndRules
        ? data.removalDateAndRules
        : this.staticRemovalData,
      salesTaxDetail: data.salesTaxDetail
        ? data.salesTaxDetail
        : this.staticSaletaxData,
      inspectionPreview: data.inspectionPreview,
      riggingAndShipping: data.riggingAndShipping
        ? data.riggingAndShipping
        : this.staticRiggingData,
      isDeleted: data.isDeleted,
    });
    this.locationForm.updateValueAndValidity();
    this.disableButton();
  }

  onDeleteLocation(index: number) {
    this.addEditLocationsList[index].isDeleted = true;
    this.locations.data = this.addEditLocationsList;
    this.onSendAndApproval(false)
    this.disableButton();
    this.closeModal();
    this.disableButton();
    this.locationForm.updateValueAndValidity();
  }

  onLocationSave() {
    this.locationSubmitted = true;
    let updatedAddress = this.locationForm.value.address.replace(/<[^>]*>?/gm, '')
    let updatedAddressData = this.addressData ? this.addressData.replace(/<[^>]*>?/gm, '') : '/'
    if (this.locationForm.invalid) {
      return;
    }
    if (updatedAddress.length > 200 || updatedAddressData.length > 200) {
      return;
    }

    if (this.isLocationEdit) {
      let arr = [...this.addEditLocationsList]
      arr.splice(this.currentLocationIndex, 1)
      if (arr.find((test) => test.name === this.locationForm.value.name && test.address === this.locationForm.value.address && test.lotNumbers === this.locationForm.value.lotNumbers && test.salesTaxDetail === this.locationForm.value.salesTaxDetail) === undefined) {
        this.addEditLocationsList.splice(
          this.currentLocationIndex,
          1,
          this.locationForm.value
        );
        this.locations.data.splice(
          this.currentLocationIndex,
          1,
          this.locationForm.value
        );
        this.onSendAndApproval(false)
        this.locations.data = this.addEditLocationsList;
        this.closeModal();
        this.disableButton();
        this.locationForm.updateValueAndValidity();
      }
      else {
        this.toastr.error('Duplicate entry')
      }
    } else {
      const result = this.addEditLocationsList.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.name === this.locationForm.value.name && t.address === this.locationForm.value.address && t.lotNumbers === this.locationForm.value.lotNumbers && t.salesTaxDetail === this.locationForm.value.salesTaxDetail
        ))
      )
      if (result.length) {
        this.toastr.error('Duplicate entry')
      }
      else {
        this.addEditLocationsList.push(this.locationForm.value);
        this.onSendAndApproval(false)
        this.locations.data = this.addEditLocationsList;
        this.closeModal();
        this.disableButton();
        this.locationForm.updateValueAndValidity();
      }


    }

  }


  resetLocationForm() {
    this.addressData = '';
    this.removalData = '';
    this.riggingData = this.staticRiggingData;
    this.saletaxData = this.staticSaletaxData;
    this.removalData = this.staticRemovalData;
    this.inspectionData = this.staticInspectionData;
    this.locationForm.reset({ id: 0, isDeleted: false });
    this.locationForm.updateValueAndValidity();
  }

  initiateContactForm() {
    this.contactForm = new FormGroup(
      {
        id: new FormControl(0),
        contactName: new FormControl(null, [
          AppValidators.noWhitespace,
          Validators.required,
          Validators.maxLength(this.fieldMaxLengthShort),
        ]),
        description: new FormControl(null, [
          AppValidators.noWhitespace,
          Validators.required,
          Validators.maxLength(this.fieldMaxLengthShort),
        ]),
        email: new FormControl(null, [
          AppValidators.checkEmail,
          AppValidators.noWhitespace,
          Validators.maxLength(this.fieldMaxLengthShort),
        ]),
        mobileNumber: new FormControl(null, [
          AppValidators.noWhitespace,
        ]),
        isDeleted: new FormControl(false),
      },
      this.isRequired.bind(this)
    );
  }

  private isRequired(formGroup: FormGroup) {
    let email = formGroup.value.email;
    let mobileNumber = formGroup.value.mobileNumber;
    if (
      (email == '' || email == null) &&
      (mobileNumber == '' || mobileNumber == null)
    ) {
      return { invalidFields: true };
    } else {
      return null;
    }
  }

  editContact(index: number) {
    let data = this.contacts.data[index];
    this.contactForm.patchValue({
      id: data.id,
      contactName: data.contactName,
      description: data.description,
      email: data.email,
      mobileNumber: data.mobileNumber,
      isDeleted: data.isDeleted,
    });
    this.disableButton();
  }

  onDeleteContact(index: number) {
    this.addEditContactsList[index].isDeleted = true;
    this.contacts.data = this.addEditContactsList;
    this.onSendAndApproval(false)
    this.disableButton();
    this.closeModal();
    this.disableButton();
  }

  onContactSave() {
    this.contactSubmitted = true;
    if (this.contactForm.invalid) {
      return;
    }
    if (this.isContactEdit) {
        this.addEditContactsList[this.currentContactIndex] = this.contactForm.value;
        this.contacts.data = this.addEditContactsList;
        this.onSendAndApproval(false)
        this.closeModal();
        this.disableButton();
    } else {
      this.addEditContactsList.push(this.contactForm.value);
      this.onSendAndApproval(false)
      this.contacts.data = this.addEditContactsList;
      this.closeModal();
      this.disableButton();
    }
  }

  resetContactForm() {
    this.contactForm.reset({
      id: 0,
      isDeleted: false,
    });
  }

  arrayLengths() {
    this.contactLength = this.addEditContactsList.filter(
      (obj) => obj.isDeleted != true
    ).length;
    this.locationLength = this.addEditLocationsList.filter(
      (obj) => obj.isDeleted != true
    ).length;
  }

  disableButton() {
    this.arrayLengths();
    if (this.contactLength <= 0) {
      this.contactDisable = true;
    } else {
      this.contactDisable = false;
    }
    if (this.locationLength <= 0) {
      this.locationDisable = true;
    } else {
      this.locationDisable = false;
    }
  }

  onSendAndApproval(isUpdated) {
    this.loading = true;
    this.loaderService.showLoader(true);

    let payLoad = this.constructFormData(isUpdated);
    const step4 = this.auctionService.addEditDeleteAuctionStep4(payLoad).subscribe(
      () => {
        this.loading = false;
        this.loaderService.showLoader(false);
        
        this.toastr.success(
          this.editMode
            ? messages.addAuction4.updated
            : messages.addAuction4.saved,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        if(isUpdated){
          this.goToStep(5);
        }
        //
      },
      (err) => {
        this.loading = false;
        this.loaderService.showLoader(false);
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      }
    );
    this.subscriptions.push(step4);
  }

  constructFormData(isUpdated) {
    let contactPayload: AuctionContact[] = this.addEditContactsList
      .map((i) => ({ ...i, email: i.email == '' ? null : i.email }))
      .filter((obj) => {
        return obj.id > 0 || (obj.id == 0 && obj.isDeleted != true);
      });
    let locationPayload: AuctionLocation[] = this.addEditLocationsList.filter(
      (obj) => {
        return obj.id > 0 || (obj.id == 0 && obj.isDeleted != true);
      }
    );
    return {
      auctionId: this.auctionId,
      auctionLocations: locationPayload,
      auctionContacts: contactPayload,
      isUpdated: isUpdated
    };
  }

  bindFormData() {
    const step4data = this.auctionService.getAuctionStep4(this.auctionId).subscribe(
      (res) => {
        this.addEditContactsList = res.auctionContacts;
        this.addEditLocationsList = res.auctionLocations;
        this.bindingData(res);
      },
      (err) => {
        this.goToStep();
      }
    );
    this.subscriptions.push(step4data);
  }
  bindingData(data: AuctionStep4) {
    this.contacts.data = data.auctionContacts;
    this.locations.data = data.auctionLocations;
    this.disableButton();
  }

  openLocationModal(
    template3: TemplateRef<any>,
    isEdit: boolean = false,
    index: number = 0
  ) {
    this.riggingData = this.staticRiggingData;
    this.saletaxData = this.staticSaletaxData;
    this.removalData = this.staticRemovalData;
    this.inspectionData = this.staticInspectionData;
    if (isEdit) {
      this.editLocation(index);
      this.showButtonText = 'Update'
      this.isLocationEdit = true;
    } else {
      this.showButtonText = 'Save'
      this.isLocationEdit = false;
    }
    this.currentLocationIndex = index;
    let modalOptions: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      class:
        'custom-popup form-modal add-location modal-dialog modal-dialog-centered max-1135',
    };
    this.modalRef = this.modalService.show(template3, modalOptions);
  }

  openContactModal(
    template2: TemplateRef<any>,
    isEdit: boolean = false,
    index: number = 0
  ) {
    if (isEdit) {
      this.editContact(index);
      this.isContactEdit = true;
      this.showButtonText = 'Update'
    } else {
      this.isContactEdit = false;
      this.showButtonText = 'Save'
    }
    this.currentContactIndex = index;
    let modalOptions: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      class:
        'custom-popup form-modal add-location modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(template2, modalOptions);
  }

  openDeleteModal(
    template2: TemplateRef<any>,
    type: number,
    index: number = 0
  ) {
    if (type == modal.Location) {
      this.modalType = modal.Location;
      this.currentLocationIndex = index;
    } else {
      this.modalType = modal.Contact;
      this.currentContactIndex = index;
    }
    let modalOptions: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      class: 'custom-popup delete-modal modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(template2, modalOptions);
  }

  closeModal() {
    this.locationSubmitted = false;
    this.contactSubmitted = false;
    this.resetLocationForm();
    this.resetContactForm();
    if (this.modalRef) this.modalRef.hide();
  }

  onCancel() {
    if (this.auctionStatus == 1) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'live' },
      });
    } else if (this.auctionStatus == 2) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'upcoming' },
      });
    } else if (this.auctionStatus == 4) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'recent' },
      });
    } else {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'pending' },
      });
    }
  }

  goToStep(step: number = 3) {
    this.step.emit(step);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
